module.exports = __webpack_public_path__ + "img/industrial-robot.03605d5d.png";